<template>
  <div
    id="print-quality-info"
    class="message print-quality-info"
    :class="[
      backgroundClass,
      { 'is-invisible': typeof currentCartItem.scale !== 'number' },
    ]"
    v-if="
      [orderProcess.STEPS.CONFIGURE_MODEL].includes(currentOrderProcessStep)
    "
  >
    <div class="message-body">
      <template v-if="printQualityMessage">
        <strong class="is-size-5">
          <SvgIcon :icon="messageIcon" class="mr-3" :class="backgroundClass" />
          {{ printQualityMessage.messageHeader }}</strong
        >
        <p v-html="printQualityMessage.messageBody" />
      </template>
      <template v-else>
        <strong class="is-size-5">
          {{
            $t(
              "checkout.analysis.printQualityInfo.printabilityIsBeingCalculated"
            )
          }}
        </strong>
        <b-skeleton width="250"></b-skeleton>
        <b-skeleton width="350"></b-skeleton>
      </template>
    </div>
  </div>
</template>

<script>
import SvgIcon from "../svg/SvgIcon";
import { PRINT_QUALITY_INFO } from "../../store/constants/print-quality-info";
import { mapGetters } from "vuex";
import { orderProcess } from "../../store/constants/order-process";
import { MATERIAL_MAPPING } from "../../store/constants/material-mapping";

export default {
  name: "PrintQualityInfo",
  components: { SvgIcon },
  data() {
    return {
      PRINT_QUALITY_INFO,
      orderProcess,
      qualityMessage: {
        type: "warning",
        messageHeader: "Dein Druckergebnis kann verbessert werden:",
        messageBody:
          "Teile des Modells könnten der gewählten Skalierung zu dünn sein. Siehe <a href='/produktion/tipps-und-tricks-im-3d-druck#cart-steps' target='_blank'>Design-Guidelines</ahref>",
      },
    };
  },
  computed: {
    ...mapGetters([
      "printQualityInfo",
      "currentOrderProcessStep",
      "currentCartItem",
    ]),
    printQualityState() {
      if (this.printQualityInfo.printabilityForSelected.tooLarge) {
        return this.PRINT_QUALITY_INFO.TO_LARGE_FOR_SELECTED_MATERIAL;
      }

      if (this.printQualityInfo.printabilityForSelected.tooSmall) {
        return this.PRINT_QUALITY_INFO.MIGHT_CAUSE_PROBLEMS;
      }

      if (this.printQualityInfo.printabilityForAll.tooLarge) {
        return this.PRINT_QUALITY_INFO.TO_LARGE_FOR_ALL_PRINTING_MODES;
      }

      if (
        this.printQualityInfo.printabilityForSelected.printable &&
        !this.printQualityInfo.printabilityForSelected.tooSmall
      ) {
        return this.PRINT_QUALITY_INFO.WITHOUT_COMPLICATIONS_PRINTABLE;
      }

      if (this.printQualityInfo.printabilityForSelected.printable === false) {
        if (this.printQualityInfo.printabilityForSelected.tooSmall) {
          return this.PRINT_QUALITY_INFO.MIGHT_CAUSE_PROBLEMS;
        }
        if (this.printQualityInfo.printabilityForSelected.tooLarge) {
          return this.PRINT_QUALITY_INFO.TO_LARGE_FOR_SELECTED_MATERIAL;
        }
        return this.PRINT_QUALITY_INFO.NOT_PRINTABLE;
      }
    },
    printQualityMessage() {
      switch (this.printQualityState) {
        case this.PRINT_QUALITY_INFO.TO_LARGE_FOR_ALL_PRINTING_MODES:
          return {
            type: "danger",
            messageHeader: this.$i18n.t(
              "checkout.analysis.printQualityInfo.tooLargeHeader"
            ),
            messageBody: "",
          };
        case this.PRINT_QUALITY_INFO.MIGHT_CAUSE_PROBLEMS:
          return {
            type: "warning",
            messageHeader: this.$i18n.t(
              "checkout.analysis.printQualityInfo.mightCauseProblemsHeader"
            ),
            messageBody: this.$i18n.t(
              "checkout.analysis.printQualityInfo.mightCauseProblemsBody"
            ),
          };
        case this.PRINT_QUALITY_INFO.WITHOUT_COMPLICATIONS_PRINTABLE:
          return {
            type: "success",
            messageHeader: this.$i18n.t(
              "checkout.analysis.printQualityInfo.filePrintableHeader"
            ),
            messageBody: this.$i18n.t(
              "checkout.analysis.printQualityInfo.filePrintableBody"
            ),
          };
        case this.PRINT_QUALITY_INFO.TO_LARGE_FOR_SELECTED_MATERIAL:
          return {
            type: "danger",
            messageHeader: this.$i18n.t(
              "checkout.analysis.printQualityInfo.tooLargeForSelectedPrintmodeHeader"
            ),
            messageBody: "",
          };
        case this.PRINT_QUALITY_INFO.NOT_PRINTABLE:
          return {
            type: "danger",
            messageHeader: this.$i18n.t(
              "checkout.analysis.printQualityInfo.notPrintableHeader"
            ),
            messageBody: this.$i18n.t(
              "checkout.analysis.printQualityInfo.notPrintableBody"
            ),
          };
      }
    },
    backgroundClass() {
      if (this.printQualityMessage) {
        return "is-" + this.printQualityMessage.type;
      } else return "";
    },
    messageIcon() {
      switch (this.printQualityMessage | this.printQualityMessage.type) {
        case "warning":
          return "icon--web-application_warning";
        case "danger":
          return "icon--web-application_warning";
        default:
          return "icon--web-application_cart";
      }
    },
  },
};
</script>

<style scoped>
</style>